import {
  EventParams,
  AnalyticsEventDefaultArgs,
} from '../Analytics/Event.types';

export type EventBucketData = {
  eventName: string;
  eventParams?: EventParams;
};

export const getEventBucket = (): EventBucketData[] => {
  return JSON.parse(
    window?.localStorage?.getItem('@Conexa:AnalyticsEventBucket') || '[]'
  );
};

export const setEventBucket = (analyticsEvent: EventBucketData): void => {
  const currentEventBucket = getEventBucket();
  return window?.localStorage?.setItem(
    '@Conexa:AnalyticsEventBucket',
    JSON.stringify([...currentEventBucket, analyticsEvent])
  );
};

export const clearEventBucket = (): void =>
  window?.localStorage?.setItem(
    '@Conexa:AnalyticsEventBucket',
    JSON.stringify([])
  );

export const appendToEventBucket = (
  ...args: AnalyticsEventDefaultArgs
): void => {
  const params = args[1] ? { ...args[1] } : {};

  const event = {
    eventName: args[0] as string,
    eventParams: params,
  };

  setEventBucket(event);
};
